import { api } from '../index';
import { TAxiosResponse } from '../baseApiTypes';
import { ICreateTemplateModel, IEmailTemplate, IEmailTemplates } from './types';

export const getEmailTemplates = (): TAxiosResponse<IEmailTemplates> =>
  api.get('/email-templates');

export const getSingleEmailTemplate = (
  id: number,
): TAxiosResponse<IEmailTemplates> => api.get(`/email-templates/${id}`);

export const createEmailTemplate = (
  data: ICreateTemplateModel,
): TAxiosResponse<IEmailTemplates> => api.post('/email-templates', data);

export const updateEmailTemplate = ({
  id,
  data,
}: {
  id: number;
  data: IEmailTemplate;
}): TAxiosResponse<IEmailTemplates> =>
  api.patch(`/email-templates/${id}`, data);

export const deleteEmailTemplate = (
  templateId: number,
): TAxiosResponse<IEmailTemplates> =>
  api.delete(`email-templates/${templateId}`);

export const EmailTemplatesApi = {
  getEmailTemplates,
  createEmailTemplate,
  getSingleEmailTemplate,
  updateEmailTemplate,
  deleteEmailTemplate,
};
